export default function getYOffsetDomUtil () {
  logUtil('getYOffsetDomUtil').debug('[start]')
  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  )
}
